<!-- Anpassunge fuer die HRK notwendig, da hier ein Zeitraum Beginn/Ende von einem Jahr geliefert wird,
die Dauer aber nur zb Eine Woch ist. Fachlich mit NOW so geklaert -->
@if (termin.beginn && termin.ende && termin.quelle?.id?.toUpperCase() !== 'HRK') {
  {{ termin.beginn! | duration: termin.ende! }}
} @else if (termin.dauerId) {
  <span [attr.aria-label]="getDauerKurzbezeichnung(termin.dauerId)">
    {{ getDauerKurzbezeichnung(termin.dauerId) }}
  </span>
} @else {
  Keine Angabe
}
